// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".element.video-player[data-v-e84666fe] .video-js {\n  width: 100%;\n  padding-top: 56.25%;\n}\n.element.video-player[data-v-e84666fe] video {\n  max-height: 100%;\n}\n.element.video-player[data-v-e84666fe] video[poster] {\n  -o-object-fit: cover;\n     object-fit: cover;\n}\n.element.video-player[data-v-e84666fe] .vjs-poster {\n  background-size: cover;\n  background-position: inherit;\n}", ""]);
// Exports
module.exports = exports;
